import request from './request'

export interface UpdateStatusParams {
  id: number
  status: number
}

export interface UpdateStatusData {
  id: number
  technician_no: string
  name: string
  mobile: string
  avatar: string
  work_role: string
  license_no?: string
  sin_type?: string
  sin_number?: string
  residency_status?: string
  address?: string
  email?: string
  status: number
  status_text: string
  settlement_config?: Record<string, unknown>
  order_stats?: {
    hmc_orders: number
    fu_orders: number
    ad_orders: number
  }
  upcoming_service?: string | null
  create_time?: string
  update_time?: string
}

export interface ApiResponse<T = unknown> {
  code: number
  data: T
  msg: string
}

export async function updateTechnicianStatus(params: UpdateStatusParams) {
  return request.post<ApiResponse<UpdateStatusData>>(
    '/api/admin/technician/update-status',
    params,
  )
}
